import { Box } from '@mui/material';
import StatisticLabelValueItem from './StatisticLabelValueItem';
import formatMoney from '../../../utils/formatMoney';
import { Statistics } from '@tassomutuo-backoffice/types';
import { CardOptions } from './DashboardContent';

interface IProps {
  statistics: Statistics;
  statisticsTrend?: Statistics;
  selectedCard: CardOptions;
  onChangeCard: (card: CardOptions) => void;
  showGoToLostRevenueDetails?: boolean;
  isPrinting?: boolean;
}

const DashboardStatisticsAllPeriod = ({
  statistics,
  statisticsTrend,
  selectedCard,
  onChangeCard,
  showGoToLostRevenueDetails = true,
  isPrinting = false,
}: IProps) => {
  return (
    <Box>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'space-around',
          flexWrap: 'wrap',
          gap: 2,
          padding: 2,
          pt: 3,
          pb: 0,
        }}
      >
        <StatisticLabelValueItem
          label="Lead ricevute"
          value={statistics.numberOfReceivedLeads}
          trendValue={statisticsTrend?.numberOfReceivedLeads}
          isSelected={selectedCard === 'receivedLeads'}
          onClick={() => onChangeCard('receivedLeads')}
          minWidthContainer={isPrinting ? 300 : 'auto'}
        />
        <StatisticLabelValueItem
          label="Mutui stimati"
          value={statistics.estimatedMortgages}
          trendValue={statisticsTrend?.estimatedMortgages}
          isEstimated
          isSelected={selectedCard === 'estimatedMortgages'}
          onClick={() => onChangeCard('estimatedMortgages')}
          minWidthContainer={isPrinting ? 300 : 'auto'}
        />
        <StatisticLabelValueItem
          label="Tasso di conversione"
          value={
            statistics.crEstimatedMortgages
              ? `${statistics.crEstimatedMortgages}%`
              : '-'
          }
          trendValue={statisticsTrend?.crEstimatedMortgages}
          isEstimated
          isSelected={selectedCard === 'conversionRate'}
          onClick={() => onChangeCard('conversionRate')}
          minWidthContainer={isPrinting ? 300 : 'auto'}
        />

        <StatisticLabelValueItem
          label="Revenue totale"
          value={formatMoney(statistics.estimatedRevenue)}
          trendValue={statisticsTrend?.estimatedRevenue}
          isEstimated
          isSelected={selectedCard === 'estimatedRevenue'}
          onClick={() => onChangeCard('estimatedRevenue')}
          minWidthContainer={isPrinting ? 300 : 'auto'}
        />
        <StatisticLabelValueItem
          label="Revenue per lead"
          value={formatMoney(statistics.revenuePerLead)}
          trendValue={statisticsTrend?.revenuePerLead}
          isEstimated
          isSelected={selectedCard === 'revenuePerLead'}
          onClick={() => onChangeCard('revenuePerLead')}
          minWidthContainer={isPrinting ? 300 : 'auto'}
        />
        <StatisticLabelValueItem
          label="Fatturato totale"
          value={formatMoney(statistics.effectiveRevenue)}
          trendValue={statisticsTrend?.effectiveRevenue}
          isSelected={selectedCard === 'effectiveRevenue'}
          onClick={() => onChangeCard('effectiveRevenue')}
          minWidthContainer={isPrinting ? 300 : 'auto'}
        />
        <StatisticLabelValueItem
          label="Fatturato perso"
          value={formatMoney(statistics.lostRevenue)}
          trendValue={statisticsTrend?.lostRevenue}
          isSelected={selectedCard === 'lostRevenue'}
          onClick={() => onChangeCard('lostRevenue')}
          valueColor="rgba(239, 68, 68, 1)"
          reverseTrend
          ctaLabel={
            !isPrinting && statistics.lostRevenue && showGoToLostRevenueDetails
              ? 'Clicca per vedere i dettagli'
              : ''
          }
          ctaLink={
            !isPrinting && statistics.lostRevenue && showGoToLostRevenueDetails
              ? '/dashboard/fatturato-perso'
              : ''
          }
          minWidthContainer={isPrinting ? 300 : 'auto'}
        />
        {statistics.crEstimatedMortgagesTotalLeads && (
          <StatisticLabelValueItem
            label="Tasso conversione totale"
            value={
              statistics.crEstimatedMortgagesTotalLeads
                ? `${statistics.crEstimatedMortgagesTotalLeads}%`
                : '-'
            }
            trendValue={statisticsTrend?.crEstimatedMortgagesTotalLeads}
            isEstimated
            isSelected={selectedCard === 'conversionRateTotalLeads'}
            onClick={() => onChangeCard('conversionRateTotalLeads')}
            minWidthContainer={isPrinting ? 300 : 'auto'}
          />
        )}
      </Box>
    </Box>
  );
};

export default DashboardStatisticsAllPeriod;
